import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { saveAs } from "file-saver";
interface FormStruct {
  id:number;
  name: string;
  email: string;
  number: string;
  content: string;
}
interface chapterstruc{
  id:number;
  name:string;
}
interface EventResitorStruct {
  id:number;
  name: string;
  number: number;
  chapId: number;
  classification:string;
  organisation:string;
  facility:string;
  transitionId:string;
  
}
interface VisitorResitorStruct {
  id:number;
  image:string;
  fullName: string;
  Mobile: number;
  Invitedby: number;
  businessName:string;
  address:string;
  companyName:string;
  transitionId:string;
  paymentDate:string;
  PaymentSS:string;
  paymentStatus:string;
  
}

interface Expformt{
  id:number;
  formName: string;
  name:string;
  email:string;
  dob:string;
  businessName:string;
  businessCategory:string;
  number:number;	
}

interface UserStructure {
  id: number;
  name: string;
  
}

const GetInTouch = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const [formData, setFormData] = useState<FormStruct[]>([]);
  const [eventRegistorData, setEventRegistorData] = useState<EventResitorStruct[]>([]);
  const [expformData, setExpformData] = useState<Expformt[]>([]);
  const [activeTab, setActiveTab] = useState('GetInTouch');
  const[chapterdata, setChapterdata] = useState<chapterstruc[]>([]);
  const[visitorregister, setVisitorRegisterData] = useState<VisitorResitorStruct[]>([]);
    const [userDetails, setuserDetails] = useState<UserStructure[]>([]);

      const [preview, setPreview] = useState<string | null>(null);

const exportToCSV = () => {
  if (!visitorregister.length) return;

  const headers = [
    "Profile Image",
    "Full Name",
    "Mobile",
    "Invited By",
    "Business Name",
    "Address",
    "Company Name",
    "Payment Status",
    "Payment Date",
    "Payment Screenshot",
    "Transaction ID"
  ];

  const rows = visitorregister.map((data) => [
    `${api}/uploads/${data.image || ""}`,
    data.fullName || "",
    data.Mobile || "",
    userDetails.find((item) => item.id == data.Invitedby)?.name || "N/A",
    data.businessName || "",
    data.address || "",
    data.companyName || "",
    data.paymentStatus || "",
    data.paymentDate || "",
    data.PaymentSS ? `${api}/uploads/${data.PaymentSS}` : "",
    data.transitionId || ""
  ]);

  // Accept string or number, convert everything to string
  const escapeCSV = (value: string | number) =>
    `"${String(value).replace(/"/g, '""')}"`;

  const csvContent =
    [headers, ...rows]
      .map((row) => row.map(escapeCSV).join(","))
      .join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  saveAs(blob, "visitors.csv");
};

const exportToCSVFormData = () => {
    if (formData.length === 0) {
      alert("No data to export");
      return;
    }

    const headers = ["Name", "Email", "Number", "Content"];
    const csvRows = [headers.join(",")];

    formData.forEach((row) => {
      csvRows.push(
        [
          `"${row.name}"`,
          `"${row.email}"`,
          `"${row.number}"`,
          `"${row.content}"`,
        ].join(",")
      );
    });

    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "formData.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportToCSVExpressInterest = () => {
    const headers = [
      "Form Name",
      "Name",
      "Email",
      "DOB",
      "Business Name",
      "Business Category",
      "Number",
    ];

    const rows = expformData.map((item) => [
      item.formName,
      item.name,
      item.email,
      item.dob,
      item.businessName,
      item.businessCategory,
      item.number,
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map((row) => row.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "expform_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

const exportEventRegisterToCSV = () => {
  if (!eventRegistorData.length) {
    alert("No data available to export");
    return;
  }

  const headers = [
    "Name",
    "Number",
    "Classification",
    "Organisation",
    "Facility",
    "Transition ID"
  ];

 const csvRows = eventRegistorData.map(row => {
  const chapter = chapterdata.find(chap => chap.id === row.chapId);
  return [
    row.name,
    row.number,
    chapter ? chapter.name : "Unknown", // Replace chapId with chapter name
    row.classification,
    row.organisation,
    row.facility,
    row.transitionId
  ];
});

  const csvContent =
    [headers, ...csvRows]
      .map(e => e.map(value => `"${value ?? ""}"`).join(","))
      .join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", "event_register.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

 useEffect(() => {
  const fetchAllUserData = async () => {
    try {
      const response = await axios.get(`${api}/auth/allusersinfo`);
      setuserDetails(response.data);
console.log(response.data)
      
    } catch (error) {
      console.error("Failed to fetch users:", error);
    }
  };

  fetchAllUserData();
}, [api]);

    useEffect (()=>{
    const fetch = async ()=>{
        try{

            const response = await axios.get(`${api}/auth/visitor-registration`);
            setVisitorRegisterData(response.data||[]);
            console.log(visitorregister)

        }
        catch(error){
   
            //console.log('error fetching point', error);
        }
    }
    fetch();
},[api])
const handleDelete = async (id: number) => {
  if (!window.confirm("Are you sure you want to delete this record?")) return;

  try {
    const response = await axios.delete(`${api}/auth/visitor-registration/${id}`);

    if (response.data && Array.isArray(response.data)) {
      // ✅ If backend returns updated list, replace state
      setVisitorRegisterData(response.data as VisitorResitorStruct[]);
    } else {
      // ✅ Otherwise, just remove from local state
      setVisitorRegisterData((prev) => prev.filter((item) => item.id !== id));
    }

    alert("Visitor deleted successfully");
    
  } catch (error) {
    console.error("Error deleting visitor:", error);
    alert("Failed to delete visitor");
  }
};
const handleDeleteGetInTouch = async (id: number) => {
  if (!window.confirm("Are you sure you want to delete this record?")) return;

  try {
    const response = await axios.delete(`${api}/auth/getintouch/${id}`);

    if (response.data && Array.isArray(response.data)) {
      // ✅ If backend returns updated list, replace state
      setFormData(response.data as FormStruct[]);
    } else {
      // ✅ Otherwise, just remove from local state
      setFormData((prev) => prev.filter((item) => item.id !== id));
    }

    alert("Get in touch deleted successfully");
    
  } catch (error) {
    console.error("Error deleting Get In Touch:", error);
    alert("Failed to delete Get In Touch");
  }
};
const handleDeleteExpressInterest = async (id: number) => {
  if (!window.confirm("Are you sure you want to delete this record?")) return;

  try {
    const response = await axios.delete(`${api}/auth/expvisitorform/${id}`);

    if (response.data && Array.isArray(response.data)) {
      // ✅ If backend returns updated list, replace state
      setExpformData(response.data as Expformt[]);
    } else {
      // ✅ Otherwise, just remove from local state
      setExpformData((prev) => prev.filter((item) => item.id !== id));
    }

    alert("Express Interest deleted successfully");
    
  } catch (error) {
    console.error("Error deleting Express Interest:", error);
    alert("Failed to delete Express Interest");
  }
};
const handleDeleteEventRegi = async (id: number) => {
  if (!window.confirm("Are you sure you want to delete this record?")) return;

  try {
    const response = await axios.delete(`${api}/auth/event-registration/${id}`);

    if (response.data && Array.isArray(response.data)) {
      // ✅ If backend returns updated list, replace state
      setEventRegistorData(response.data as EventResitorStruct[]);
    } else {
      // ✅ Otherwise, just remove from local state
      setEventRegistorData((prev) => prev.filter((item) => item.id !== id));
    }

    alert("EventResitorStruct deleted successfully");
    
  } catch (error) {
    console.error("Error deleting EventResitorStruct:", error);
    alert("Failed to delete EventResitorStruct");
  }
};
  useEffect (()=>{
    const fetch = async ()=>{
        try{

            const response = await axios.get(`${api}/auth/chapter`);
            setChapterdata(response.data.data);

        }
        catch(error){
   
            //console.log('error fetching point', error);
        }
    }
    fetch();
})

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<{ message: string; data: EventResitorStruct[] }>(
          `${api}/auth/event-registration`
        );

        //console.log('response data ', response);

        // Assuming `data` is wrapped in the `response.data`
        setEventRegistorData(response.data.data);
      } catch (error) {
        console.error('Form details not found: ', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<{ message: string; data: FormStruct[] }>(
          `${api}/auth/getintouch`
        );

        //console.log('response data ', response);

        // Assuming `data` is wrapped in the `response.data`
        setFormData(response.data.data);
      } catch (error) {
        console.error('Form details not found: ', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${api}/auth/expvisitorform`
        );

        //console.log('response data ', response);

        // Assuming `data` is wrapped in the `response.data`
        setExpformData(response.data.data);
      } catch (error) {
        console.error('Form details not found: ', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="w-[100%] shadow-lg rounded-lg p-6">
      <h1 className="text-2xl font-bold text-center text-gray-800 mb-6">Form Data</h1>
      
      {/* Tab Buttons */}
      <div className="flex flex-wrap  mb-6 gap-3 justify-around">
  <button
    className={`px-4 py-2 mx-2 rounded-t-lg w-[250px]  h-[50px] ${
      activeTab === 'GetInTouch' ? 'bg-darkblue text-white' : 'bg-gray-100 text-gray-800'
    }`}
    onClick={() => setActiveTab('GetInTouch')}
  >
    Get in Touch
  </button>
  <button
    className={`px-4 py-2 mx-2 w-[250px] rounded-t-lg ${
      activeTab === 'ExpressInterest' ? 'bg-darkblue text-white' : 'bg-gray-100 text-gray-800'
    }`}
    onClick={() => setActiveTab('ExpressInterest')}
  >
    Express Interest
  </button>
  <button
    className={`px-4 py-2 mx-2 w-[250px] rounded-t-lg ${
      activeTab === 'VisitorRegistration' ? 'bg-darkblue text-white' : 'bg-gray-100 text-gray-800'
    }`}
    onClick={() => setActiveTab('VisitorRegistration')}
  >
    Visitor Registration
  </button>
  <button
    className={`px-4 py-2 mx-2 w-[250px] rounded-t-lg ${
      activeTab === 'EventRegistration' ? 'bg-darkblue text-white' : 'bg-gray-100 text-gray-800'
    }`}
    onClick={() => setActiveTab('EventRegistration')}
  >
    Event Registration
  </button>
</div>

      {/* Tab Content */}
      <div className="overflow-x-auto">
        {activeTab === 'GetInTouch' && (
          <div>
              <button
        onClick={exportToCSVFormData}
        className="mb-3 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
      >
        Export CSV
      </button>
            <table className="w-[100%] border-collapse border border-gray-200">
              <thead>
                <tr className="bg-darkblue text-white">
                  <th className="px-4 py-3 border border-gray-200 text-left">Name</th>
                  <th className="px-4 py-3 border border-gray-200 text-left">Email</th>
                  <th className="px-4 py-3 border border-gray-200 text-left">Number</th>
                  <th className="px-4 py-3 border border-gray-200 text-left">Message</th>
                  <th className="px-4 py-3 border border-gray-200 text-left">Action</th>

                </tr>
              </thead>
              <tbody>
                {formData.map((data, index) => (
                  <tr
                    key={index}
                    className={`${
                      index % 2 === 0 ? 'bg-gray-100' : 'bg-white'
                    } hover:bg-gray-200`}
                  >
                    <td className="px-4 py-3 border border-gray-200">{data.name}</td>
                    <td className="px-4 py-3 border border-gray-200">
                      <a href={`mailto:${data.email}`}>{data.email}</a>
                    </td>
                    <td className="px-4 py-3 border border-gray-200">
                      <a href={`tel:+${data.number}`}>{data.number}</a>
                    </td>
                    <td className="px-4 py-3 border border-gray-200">{data.content}</td>

                    {/* Delete Button */}
              <td className="px-4 py-3 border border-gray-200">
                <button
                  onClick={() => handleDeleteGetInTouch(data.id)}
                  className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700"
                >
                  Delete
                </button>
              </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {activeTab === 'ExpressInterest' && (
          <div>
            <div className='flex gap-3'>
              <button
        onClick={exportToCSVExpressInterest}
        className="mb-3 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
      >
        Export CSV
      </button>
       <button
    onClick={() => {
      navigator.clipboard.writeText(window.location.origin + "/express-interest");
      alert("Link copied to clipboard!");
    }}
    className="mb-3 px-4 py-2 bg-green-600 text-white rounded hover:bg-blue-900"
  >
    Copy Link
  </button>
            </div>
                 
            <table className="w-[100%] border-collapse border border-gray-200">
              <thead>
                <tr className="bg-darkblue text-white">
                  <th className="px-4 py-3 border border-gray-200 text-left">Name</th>
                  <th className="px-4 py-3 border border-gray-200 text-left">Email</th>
                  <th className="px-4 py-3 border border-gray-200 text-left">Business Name</th>
                  <th className="px-4 py-3 border border-gray-200 text-left">Business Category</th>
                  <th className="px-4 py-3 border border-gray-200 text-left">Number</th>
                  <th className="px-4 py-3 border border-gray-200 text-left">Action</th>
                </tr>
              </thead>
              <tbody>
                {expformData
                  .filter((items) => items.formName === 'Express')
                  .map((data, index) => (
                    <tr
                      key={index}
                      className={`${
                        index % 2 === 0 ? 'bg-gray-100' : 'bg-white'
                      } hover:bg-gray-200`}
                    >
                      <td className="px-4 py-3 border border-gray-200">{data.name}</td>
                      <td className="px-4 py-3 border border-gray-200">
                        <a href={`mailto:${data.email}`}>{data.email}</a>
                      </td>
                      <td className="px-4 py-3 border border-gray-200">{data.businessName}</td>
                      <td className="px-4 py-3 border border-gray-200">{data.businessCategory}</td>
                      <td className="px-4 py-3 border border-gray-200">{data.number}</td>
                      {/* Delete Button */}
              <td className="px-4 py-3 border border-gray-200">
                <button
                  onClick={() => handleDeleteExpressInterest(data.id)}
                  className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700"
                >
                  Delete
                </button>
              </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}

        {activeTab === 'VisitorRegistration' && (
          <div>
      {/* Export CSV Button */}
      <div className='flex gap-3'>
      <button
        onClick={exportToCSV}
        className="mb-3 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
      >
        Export CSV
      </button>
      <button

    onClick={() => {
      navigator.clipboard.writeText(window.location.origin + "/visitor-registration");
      alert("Link copied to clipboard!");
    }}
    className="mb-3 px-4 py-2 bg-green-600 text-white rounded hover:bg-blue-900"
  >
    Copy Link
  </button>
  </div>

      <table className="w-[100%] border-collapse border border-gray-200">
        <thead>
          <tr className="bg-darkblue text-white">
            <th className="px-4 py-3 border border-gray-200 text-left">Profile Image</th>
            <th className="px-4 py-3 border border-gray-200 text-left">Full Name</th>
            <th className="px-4 py-3 border border-gray-200 text-left">Mobile</th>
            <th className="px-4 py-3 border border-gray-200 text-left">Invited By</th>
            <th className="px-4 py-3 border border-gray-200 text-left">Business Name</th>
            <th className="px-4 py-3 border border-gray-200 text-left">Address</th>
            <th className="px-4 py-3 border border-gray-200 text-left">Company Name</th>
            <th className="px-4 py-3 border border-gray-200 text-left">Payment Status</th>
            <th className="px-4 py-3 border border-gray-200 text-left">Payment Date</th>
            <th className="px-4 py-3 border border-gray-200 text-left">Payment SS</th>
            <th className="px-4 py-3 border border-gray-200 text-left">Transaction ID</th>
            <th className="px-4 py-3 border border-gray-200 text-left">Action</th>
          </tr>
        </thead>
        <tbody>
          {visitorregister.map((data, index) => (
            <tr
              key={index}
              className={`${index % 2 === 0 ? "bg-gray-100" : "bg-white"} hover:bg-gray-200`}
            >
              {/* Image */}
              <td className="px-4 py-3 border border-gray-200">
                <img
                  src={`${api}/uploads/${data.image}`}
                  alt={data.fullName || "Visitor"}
                  className="w-16 h-16 object-cover rounded"
                />
              </td>

              {/* Full Name */}
              <td className="px-4 py-3 border border-gray-200">{data.fullName}</td>

              {/* Mobile */}
              <td className="px-4 py-3 border border-gray-200">{data.Mobile}</td>

              {/* Invited By */}
              <td className="px-4 py-3 border border-gray-200">
                {userDetails.find((item) => item.id == data.Invitedby)?.name || "N/A"}
              </td>

              {/* Business Name */}
              <td className="px-4 py-3 border border-gray-200">{data.businessName}</td>

              {/* Address */}
              <td className="px-4 py-3 border border-gray-200">{data.address}</td>

              {/* Company Name */}
              <td className="px-4 py-3 border border-gray-200">{data.companyName}</td>

              {/* Payment Status */}
              <td className="px-4 py-3 border border-gray-200">{data.paymentStatus}</td>

              {/* Payment Date */}
             <td className="px-4 py-3 border border-gray-200">
  {data.paymentDate ? new Date(data.paymentDate).toLocaleDateString() : ""}
</td>


              <td className="px-4 py-3 border border-gray-200">
        {data.PaymentSS ? (
          <img
            src={`${api}/uploads/${data.PaymentSS}`}
            alt="Payment Screenshot"
            className="w-16 h-16 object-cover rounded cursor-pointer hover:scale-105 transition"
            onClick={() => setPreview(`${api}/uploads/${data.PaymentSS}`)}
          />
        ) : (
          "N/A"
        )}
      </td>

      {/* Modal */}
      {preview && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={() => setPreview(null)} // close on background click
        >
          <div className="relative">
            <img
              src={preview}
              alt="Full Screenshot"
              className="max-w-[90vw] max-h-[90vh] rounded-lg shadow-xl"
            />
            {/* Close button */}
            <button
              className="absolute top-2 right-2 bg-white text-black rounded-full px-3 py-1 text-sm font-bold shadow hover:bg-gray-200"
              onClick={() => setPreview(null)}
            >
              ✕
            </button>
          </div>
        </div>
      )}

              {/* Transaction ID */}
              <td className="px-4 py-3 border border-gray-200">{data.transitionId}</td>

              {/* Delete Button */}
              <td className="px-4 py-3 border border-gray-200">
                <button
                  onClick={() => handleDelete(data.id)}
                  className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
        )}
         {activeTab === 'EventRegistration' && (
          <div>
            <div className='flex gap-3'>
                 <button
        onClick={exportEventRegisterToCSV}
        className="mb-3 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
      >
        Export CSV
      </button>
      <button

    onClick={() => {
      navigator.clipboard.writeText(window.location.origin + "/event-register");
      alert("Link copied to clipboard!");
    }}
    className="mb-3 px-4 py-2 bg-green-600 text-white rounded hover:bg-blue-900"
  >
    Copy Link
  </button>
  </div>
            <table className="w-[100%] border-collapse border border-gray-200">
              <thead>
                <tr className="bg-darkblue text-white">
                  <th className="px-4 py-3 border border-gray-200 text-left">Name</th>
                  <th className="px-4 py-3 border border-gray-200 text-left hidden">Chapter Name</th>
                  <th className="px-4 py-3 border border-gray-200 text-left">Mobile Number</th>
                  <th className="px-4 py-3 border border-gray-200 text-left">Classification</th>
                  <th className="px-4 py-3 border border-gray-200 text-left">Organisation</th>
                  <th className="px-4 py-3 border border-gray-200 text-left">Facility</th>
                  <th className="px-4 py-3 border border-gray-200 text-left">Transition Id</th>
                  <th className="px-4 py-3 border border-gray-200 text-left">Action</th>
                </tr>
              </thead>
              <tbody>
                {eventRegistorData.map((data, index) => (
                    <tr
                      key={index}
                      className={`${
                        index % 2 === 0 ? 'bg-gray-100' : 'bg-white'
                      } hover:bg-gray-200`}
                    >
                      <td className="px-4 py-3 border border-gray-200">{data.name}</td>
                      <td className="px-4 py-3 border border-gray-200 hidden">
                      {
        chapterdata.find((item) => item.id === data.chapId)?.name || 'N/A'
      }
                      </td>
                      <td className="px-4 py-3 border border-gray-200">{data.number}</td>
                      <td className="px-4 py-3 border border-gray-200">{data.classification}</td>
                      <td className="px-4 py-3 border border-gray-200">{data.organisation}</td>
                      <td className="px-4 py-3 border border-gray-200">{data.facility}</td>
                      <td className="px-4 py-3 border border-gray-200">{data.transitionId}</td>
                      {/* Delete Button */}
              <td className="px-4 py-3 border border-gray-200">
                <button
                  onClick={() => handleDeleteEventRegi(data.id)}
                  className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700"
                >
                  Delete
                </button>
              </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default GetInTouch;
